import { isProduction } from '~utils/env-provider'

let secureFields

if (isProduction) {
  secureFields = require('~plugins/secure-fields/secure-fields-2.0.0') // eslint-disable-line @typescript-eslint/no-var-requires
} else {
  secureFields = require('~plugins/secure-fields/secure-fields-2.0.0.sandbox') // eslint-disable-line @typescript-eslint/no-var-requires
}

export default secureFields as any
